import { defineComponent as S, ref as v, watch as r, computed as h, openBlock as s, createElementBlock as l, normalizeClass as C, unref as n, createVNode as b, withCtx as y, Fragment as E, renderList as P, createBlock as k } from "vue";
import { ElSelect as B, ElOption as N } from "./index539.js";
import { usePagination as L } from "./index746.js";
import { paginationSizesProps as _ } from "./index747.js";
import { useLocale as q } from "./index597.js";
import { useNamespace as A } from "./index559.js";
import { isArray as F } from "./index575.js";
import O from "./index712.js";
var K = /* @__PURE__ */ S({
  name: "ElPaginationSizes",
  __name: "sizes",
  props: _,
  emits: ["page-size-change"],
  setup(m, { emit: u }) {
    const a = m, c = u, { t: d } = q(), g = A("pagination"), t = L(), o = v(a.pageSize);
    r(
      () => a.pageSizes,
      (e, i) => {
        if (!O(e, i) && F(e)) {
          const p = e.includes(a.pageSize) ? a.pageSize : a.pageSizes[0];
          c("page-size-change", p);
        }
      }
    ), r(
      () => a.pageSize,
      (e) => {
        o.value = e;
      }
    );
    const z = h(() => a.pageSizes);
    function f(e) {
      var i;
      e !== o.value && (o.value = e, (i = t.handleSizeChange) == null || i.call(t, Number(e)));
    }
    return (e, i) => (s(), l(
      "span",
      {
        class: C(n(g).e("sizes"))
      },
      [
        b(n(B), {
          "model-value": o.value,
          disabled: e.disabled,
          "popper-class": e.popperClass,
          "popper-style": e.popperStyle,
          size: e.size,
          teleported: e.teleported,
          "validate-event": !1,
          "append-to": e.appendSizeTo,
          onChange: f
        }, {
          default: y(() => [
            (s(!0), l(
              E,
              null,
              P(z.value, (p) => (s(), k(n(N), {
                key: p,
                value: p,
                label: p + n(d)("el.pagination.pagesize")
              }, null, 8, ["value", "label"]))),
              128
              /* KEYED_FRAGMENT */
            ))
          ]),
          _: 1
          /* STABLE */
        }, 8, ["model-value", "disabled", "popper-class", "popper-style", "size", "teleported", "append-to"])
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  K as default
};
